export const GROUPS = {
  SALVUS_ADMIN: 1,
  GROUP_ADMIN: 2,
  GROUP_DEFAULT: 3,
  PROFESSIONAL: 4
};

export const CENE_CLIENT_ID = [4, 5, 13];

export const ACCESS = {
  CLIENT: 1,
  BUSINESS_PARTNER: 2
};

export const LABOR_BOND = {
  CLT: 1,
  COLABORADOR: 2,
  PJ: 3
};

export const VISIT_REPORT_TYPE = ['1015', '1016', '1028', '1029', '1031'];

export const EXTENSION_REPORT_TYPE = ['1016', '1028', '1029', '1031', '1032'];
